export default __webpack_public_path__ + "static/media/raychat-logo-english.783e7648.svg";